import Head from 'expo-router/head';
import { useIntl } from 'react-intl';

import { LoyaltyHistoryWidget, LoyaltyRewardsListWidget } from '../loyalty-widgets';

export const LoyaltyDashboardView = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <Head>
        <title>{`${formatMessage({ id: 'rewards' })} - Firehouse Subs`}</title>
      </Head>
      <LoyaltyHistoryWidget />
      <LoyaltyRewardsListWidget />
    </>
  );
};
